<template>
  <div class="NotFound">
    <AppHeader logoLink="/" />
    <div class="main-body">
      <div class="body-icon">
        <i class="iconfont Ghost"></i>
      </div>
      <div class="body-tips">
        <div>{{ $t('notfound.error') }}</div>
        <div>{{ $t('notfound.tips') }}</div>
      </div>
      <div class="body-button" @click="goHome">{{ $t('notfound.button') }}</div>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader'
import AppFooter from '../components/AppFooter'

export default {
  name: 'NotFound',
  components: { AppHeader, AppFooter },
  methods: {
    goHome() {
      this.$router.replace('/')
    },
  },
}
</script>

<style scoped lang="less">
.NotFound {
  width: 100%;

  .main-body {
    padding-top: 155px;
    padding-bottom: 132px;

    .body-icon {
      margin-top: 50px;
      text-align: center;

      .iconfont {
        font-size: 62px;
        color: rgba(0, 0, 0, 0.5);
      }
    }

    .body-tips {
      margin-top: 40px;
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      text-align: center;
    }

    .body-button {
      margin: 30px auto 15px;
      width: 108px;
      height: 36px;
      background: rgba(153, 210, 13, 1);
      box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      line-height: 36px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
